import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 3px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// @ts-nocheck
import React from 'react';
import MediaQuery from 'react-responsive';
import { isEmpty } from 'ramda';
import { Ink } from '../../Ink';
import { ScreenReaderOnly } from '../../ScreenReaderOnly';
import styled from '../../utils/styling/styled-components';
import { SELECT_INPUT, SELECT_INPUT_OPTION } from '../../utils/testing/TestIDs';
import { FieldError } from '../FieldError';
import { enhance } from './enhance';
import { Container, Label, Option, Options, Overlay, Placeholder, Select } from './styled-components';
var StyledFieldError = styled(FieldError)(_templateObject());
var SelectInput = enhance(function (props) {
  return /*#__PURE__*/React.createElement(Container, {
    className: props.className,
    ref: props.handleContainerRef,
    "data-disabled": props.disabled,
    "data-testid": SELECT_INPUT
  }, props.hasHiddenLabel ? /*#__PURE__*/React.createElement(ScreenReaderOnly, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: props.id
  }, props.label)) : /*#__PURE__*/React.createElement(Label, {
    htmlFor: props.id
  }, props.label), props.useNative ? /*#__PURE__*/React.createElement(Select, {
    placeholderVisible: !props.value && !isEmpty(props.placeholder),
    "data-error": props.error,
    id: props.id,
    name: props.name,
    onChange: props.handleChange,
    onMouseDown: props.handleMouseDown,
    onKeyUp: props.handleKeyUp,
    value: props.value,
    disabled: props.disabled,
    "data-testid": props.testId
  }, /*#__PURE__*/React.createElement(React.Fragment, null, props.placeholder && /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true,
    hidden: true
  }, props.placeholder), props.options.map(function (_ref) {
    var label = _ref.label,
        value = _ref.value;
    return /*#__PURE__*/React.createElement("option", {
      key: value,
      value: value
    }, label);
  }))) : /*#__PURE__*/React.createElement(Select, {
    as: "div",
    "data-error": props.error,
    id: props.id,
    name: props.name,
    disabled: props.disabled,
    onMouseDown: props.handleMouseDown,
    "data-testid": props.testId,
    tabIndex: 0,
    ref: props.handleSelectRef,
    onKeyDown: props.handleKeyDown
  }), props.error && props.errorText && /*#__PURE__*/React.createElement(StyledFieldError, {
    errorText: props.errorText,
    fieldId: props.id
  }), !props.useNative && props.active && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: props.theme.breakpoints.md
  }, /*#__PURE__*/React.createElement(Overlay, {
    onClick: props.handleOverlayClick
  })), /*#__PURE__*/React.createElement(Options, {
    ref: props.handleListRef,
    id: SELECT_INPUT_OPTION,
    label: props.label,
    offsetTop: props.offsetTop,
    position: props.position,
    role: "list",
    tabIndex: -1
  }, props.renderMenu ? props.renderMenu(props) : props.options.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value,
        subtext = _ref2.subtext;
    return /*#__PURE__*/React.createElement(Option, {
      "data-value": value,
      key: value,
      id: "".concat(SELECT_INPUT_OPTION, "_").concat(value.toLowerCase().replace(' ', '_')),
      onClick: props.handleOptionClick,
      onKeyDown: props.handleKeyDown,
      role: "listitem",
      "data-testid": SELECT_INPUT_OPTION,
      tabIndex: 0,
      keyboardSelected: props.keyboardSelected === value
    }, props.renderOption(label, value === props.value, value, subtext), /*#__PURE__*/React.createElement(Ink, {
      opacity: 0.02
    }));
  }))), !props.useNative && props.renderSelected(props), !props.useNative && !props.value && props.placeholder && /*#__PURE__*/React.createElement(Placeholder, null, props.placeholder));
});
export { SelectInput };